import { Badge } from '@mantine/core';
import { worklistState, type ClosedReason, type WorklistState } from '@taksikortti/shared';
import { t } from '../lib/strings';

// One badge for BOTH lifecycles (kertakortti case status, taksikortti duplicate
// reviewStatus, per-trip status). Raw values map to a shared vocabulary via
// worklistState() so words + colours are consistent everywhere.
const COLORS: Record<WorklistState, string> = {
  avoin: 'gray',
  kysely: 'blue',
  muistutus: 'orange',
  tarkistettava: 'red',
  valmis: 'green',
};

export function StateBadge({ status, closedReason }: { status: string; closedReason?: ClosedReason | null }) {
  const key = worklistState(status);
  const label = key === 'valmis' && closedReason
    ? `${t.state.valmis} · ${t.closedReason[closedReason]}`
    : t.state[key];
  return (
    <Badge color={COLORS[key]} variant="light" radius="sm" size="sm">
      {label}
    </Badge>
  );
}
